import React from "react";

const CCTV = () => {
  return (
    <div className="page-shell">
      <div className="page-hero-card">
        <span className="page-hero-badge">Monitoring Visual</span>
        <h2 className="page-hero-title">CCTV</h2>
        <p className="page-hero-subtitle">
          Halaman CCTV masih dalam tahap pengembangan. Nantinya halaman ini akan
          digunakan untuk menampilkan kamera pemantauan depot secara real-time.
        </p>
      </div>

      <div className="page-card">
        <div className="page-card-header">
          <div>
            <h3 className="section-title">Status Pengembangan</h3>
            <p className="section-subtitle">
              Fitur CCTV belum aktif. Silakan lanjutkan ke halaman lain yang sudah tersedia.
            </p>
          </div>
        </div>

        <div className="empty-state-box">
          Fitur CCTV masih under construction.
        </div>
      </div>
    </div>
  );
};

export default CCTV;